import { cn } from '@/lib/utils'

const styles = {
  Pending: 'bg-blue-50 text-blue-700',
  Viewed: 'bg-amber-50 text-amber-700',
  'In chat': 'bg-green-50 text-green-700',
  default: 'bg-slate-100 text-slate-700',
} as const

export function Badge({
  children,
  tone = 'default',
  className,
}: {
  children: React.ReactNode
  tone?: keyof typeof styles
  className?: string
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold',
        styles[tone],
        className,
      )}
    >
      {children}
    </span>
  )
}
